import React from 'react';
import { CardRounded, IconCard, IconCheckBanking } from '@americanexpress/dls-react';
import styles from 'src/components/atomic/pages/ineligible/IneligibleView.module.scss';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import colors from 'src/styles/colors.module.scss';
import LiteralsService from 'src/services/literals/LiteralsService';
import Typography from 'src/components/typography/Typography';

import WideView from 'src/components/atomic/layouts/wideView/WideView';
import { DLSSize } from 'src/types/dls-size.enum';
import { useSpendSmartDocumentTitle } from 'src/hooks/useDocumentTitle';
import { useTrackPage } from 'src/hooks/useAdobeTags';
import adobeTags from 'src/types/adobe-tags';
import Anchor from 'src/components/atomic/atoms/anchor/Anchor';

const iconTheme = {
    color: '#006fcf',
    fill: '#006fcf',
    marginRight: '10px'
};

export default function IneligibleView(): JSX.Element {
    useSpendSmartDocumentTitle(LiteralsService.getLiteral('Budget.titles.ineligible'));
    useTrackPage(LiteralsService.getLiteral('Budget.titles.ineligible'));
    return (
        <WideView showFooter hideBackButton disableNotificationBanners>
            <div className={styles.contentArea}>
                <CardRounded className={styles.contentContainer}>
                    <div className={styles.heading}>
                        <Typography
                            variant={TypographyVariants.HEADING_M}
                            className={colors.brandStrong}
                            component="h1"
                        >
                            {LiteralsService.getLiteral('Ineligible.heading')}
                        </Typography>
                    </div>
                    <div className={styles.listContainer}>
                        <ul className={styles.list}>
                            <li className={styles.listItem}>
                                <IconCard size={DLSSize.SMALL} theme={iconTheme} />
                                <Typography variant={TypographyVariants.SUBTEXT}>
                                    {LiteralsService.getLiteral('Ineligible.basic')}
                                </Typography>
                            </li>
                            <li className={styles.listItem}>
                                <IconCheckBanking size={DLSSize.SMALL} theme={iconTheme} />
                                <Typography variant={TypographyVariants.SUBTEXT}>
                                    {LiteralsService.getLiteral('Ineligible.checking')}
                                </Typography>
                            </li>
                        </ul>
                    </div>
                    <p className={styles.body}>
                        <Typography variant={TypographyVariants.SUBTEXT} className="textDefault block">
                            {LiteralsService.getLiteral('Ineligible.body[0]')}

                            <Anchor
                                href="https://www.americanexpress.com/us/credit-cards/?extlink=mfp-budgeting-5NN"
                                tag={adobeTags.Eligibility}
                                inline
                            >
                                {LiteralsService.getLiteral('Ineligible.anchorText.americanExpressCards')}
                            </Anchor>

                            {LiteralsService.getLiteral('Ineligible.body[1]')}
                        </Typography>
                        <br />
                        <Typography variant={TypographyVariants.SUBTEXT}>
                            {LiteralsService.getLiteral('Ineligible.rewardsChecking')}
                        </Typography>
                    </p>
                </CardRounded>
            </div>
        </WideView>
    );
}
